<template>
<div>
    <Breadcrumbs main="Admin" submain="Subscription" title="Paid & Activated" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <b-row class="d-flex justify-content-center align-items-center">
                            <b-col xl="6" class="d-flex flex-wrap" style="gap: 20px">
                                <b-input-group style="width: 340px;">
                                    <b-form-input v-model="user_name" @keyup="searchUsers" placeholder="Type to Search"></b-form-input>
                                    <b-input-group-append>
                                        <b-button @click="clearSearch">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div class="row mt-1">
                            <div class="col-md-3">
                                <div class="grid-container mt-sm-0">
                                    <div class="grid-item">
                                        <span style="margin-bottom: 4px;">Subscription Package</span>
                                        <b-form-select v-model="package" :options="formattedPackage"></b-form-select>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="grid-container mt-sm-0">
                                    <div class="grid-item">
                                        <span>Date From</span>
                                        <div class="form-group">
                                            <input type="date" class="form-control" v-model="date_from">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="grid-container mt-sm-0">
                                    <div class="grid-item">
                                        <span>Date To</span>
                                        <div class="form-group">
                                            <input type="date" class="form-control" v-model="date_to">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style="margin-top: 20px; display: flex; align-items: center; text-align: center; justify-content: center; color: white; background-color: #262062; padding: 2px 14px; width: 100px; border-radius: 5px; cursor: pointer; height: 39px;" @click="filterUserList()">
                                <h7>Filter</h7>
                            </div>
                            <div v-if="filterShow" style="margin-top: 20px; margin-left: 12px; display: flex; align-items: center; text-align: center; justify-content: center; color: white; background-color: #DC3545; padding: 2px 14px; width: 100px; border-radius: 5px; cursor: pointer; height: 39px;" @click="resetFilters()">
                                <h7>Reset</h7>
                            </div>
                        </div>

                        <div v-if="!loading && !error && !loadingPage">
                            <div class="table-responsive datatable-vue mt-2">
                                <b-table :items="subscriber_list" :fields="tablefields" :per-page="perPage" show-empty stacked="md">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(user_object)="row">
                                        <div style="display: flex; flex-direction: column; gap: 4px;">
                                            <h7>{{ row.item.user_object?.first_name }} {{ row.item.user_object?.last_name }}</h7>
                                            <b-badge style="font-size: 13px; max-width: fit-content;">{{ row.item.user_object?.email }}</b-badge>
                                        </div>
                                    </template>

                                    <template #cell(phone_no)="row">
                                        <h7>{{ row.item.personal_info?.phone_number }}</h7>
                                    </template>

                                    <template #cell(package)="row">
                                        <h7 v-if="row.item.subscription_info">{{ row.item.subscription_info?.title }}</h7>
                                    </template>

                                    <template #cell(successful_payments)="row">
                                        <b-badge variant="primary" style="font-size: small; cursor: pointer;" v-if="row.item.payment_summary" @click="togglePaymentTable(row.item.personal_info.user)">{{ row.item.payment_summary?.successful_payment_count }}</b-badge>
                                        <div class="small-table-container mt-2" v-if="expandedRows[row.item.personal_info.user]">
                                            <table class="small-table">
                                                <thead>
                                                    <tr>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="payment in row.item.payment_summary?.successful_payments" :key="payment.id">
                                                        <td>{{ payment.amount }}</td>
                                                        <td>{{ formatDate(payment.payment_date).date }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </template>

                                    <template #cell(wallet_balance)="row">
                                        <router-link :to="{ path: '/subscription/user/wallet', query: { user_id: row.item.user_object?.id } }">
                                            <b-badge variant="primary" style="font-size: small;">{{ row.item.personal_info?.wallet_balance }}</b-badge>
                                            <p style="padding-top: 8px; font-weight: 600; border-bottom: 2px solid #262062; width: 54px;">History</p>
                                        </router-link>
                                    </template>

                                    <template #cell(subscription_info.start_date)="row">
                                        <h7 v-if="row.item.subscription_info">{{ formatDate(row.item.subscription_info?.start_date).date }} <br> {{ formatDate(row.item.subscription_info?.start_date).time }}</h7>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>

                        <b-row class="mt-3">
                            <b-col xl="12" class="d-flex flex-wrap justify-content-start align-items-center" style="gap: 8px;">
                                <span>
                                    <!-- First Page Button (<<) -->
                                    <button class="pg-button" :disabled="currentPage === 1" @click="goToPage(1)">
                                        <b-icon icon="chevron-double-left"></b-icon>
                                    </button>

                                    <!-- Previous Page Button (<) -->
                                    <button class="pg-button ml-2" :disabled="currentPage === 1" @click="goToPage(currentPage - 1)">
                                        <b-icon icon="chevron-left"></b-icon>
                                    </button>
                                </span>

                                <!-- Page Number Display (Page X of Y) -->
                                <span class="align-self-center">
                                    <span class="align-self-center">
                                        <span class="d-flex align-items-center" style="gap: 6px;">
                                            <span>Page</span>
                                            <b-form-input v-model="currentPage" style="box-shadow: none; width: 54px; text-align: center;" @blur="validatePage" @keydown.enter="validatePage" :disabled="totalPages <= 1"></b-form-input>
                                            <span>of {{ totalPages }}</span>
                                        </span>
                                    </span>
                                </span>

                                <span>
                                    <!-- Next Page Button (>) -->
                                    <button class="mr-2 pg-button" :disabled="currentPage === totalPages" @click="goToPage(currentPage + 1)">
                                        <b-icon icon="chevron-right"></b-icon>
                                    </button>

                                    <!-- Last Page Button (>>) -->
                                    <button class="pg-button" :disabled="currentPage === totalPages" @click="goToPage(totalPages)">
                                        <b-icon icon="chevron-double-right"></b-icon>
                                    </button>
                                </span>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import {
    myHost
} from '../../../_helpers/host';
import loader from '../loader/loader.vue';
import Multiselect from 'vue-multiselect';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    components: {
        loader,
        Multiselect
    },

    data() {
        return {
            host: myHost.host,
            selected: [],
            isDisabled: false,
            subscriber: {

            },
            expandedRows: {},
            tablefields: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'user_object',
                    label: 'Subscriber',
                    sortable: false
                },
                {
                    key: 'phone_no',
                    label: 'Phone No',
                    sortable: false
                },
                {
                    key: 'wallet_balance',
                    label: 'Balance (Coin)',
                    sortable: false
                },
                {
                    key: 'package',
                    label: 'Last Package',
                    sortable: false
                },
                {
                    key: 'subscription_info.start_date',
                    label: 'Last Payment Date',
                    sortable: true
                },
                {
                    key: 'successful_payments',
                    label: 'Successful Payments',
                    sortable: false
                }
            ],
            types: [{
                    text: 'Monthly',
                    value: 'monthly'
                },
                {
                    text: 'Yearly',
                    value: 'yearly'
                }
            ],
            date_from: null,
            date_to: null,
            show_table: false,
            initialLoad: true,
            filterShow: false,
            package: null,
            user_name: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 25,
            loadingPage: false,
            pageOptions: [25, 50, 100]
        };
    },

    computed: {
        ...mapState({
            packages: state => state.packages.package,
            subscriber_list: state => state.subscriber.activated,
            loading: state => state.subscriber.subscriberLoading,
            error: state => state.subscriber.subscriberError,
            count: state => state.subscriber.activated_count
        }),

        formattedPackage() {
            return [{
                    value: null,
                    text: 'Select a subscription package',
                    disabled: true
                },
                ...this.packages.map(pkg => ({
                    value: pkg.id,
                    text: pkg.title
                }))
            ];
        },

        formattedType() {
            return [{
                    value: null,
                    text: 'Select a subscription type',
                    disabled: true
                },
                ...this.types.map(type => ({
                    value: type.value,
                    text: type.text
                }))
            ];
        },

        totalPages() {
            if (typeof this.totalRows === 'number' && !isNaN(this.totalRows) && this.totalRows > 0) {
                return Math.ceil(this.totalRows / this.perPage);
            }
            return 1; // Default to 1 if totalRows is invalid
        }
    },

    watch: {
        currentPage(newCurrentPage) {
            if (!this.initialLoad) {
                if (this.currentPage === null || this.currentPage === '') {
                    this.loadingPage = true
                }
                if (this.package != null && this.package !== '' && this.package !== NaN) {
                    this.$router.replace({
                        path: '/subscription/activated/list',
                        query: {
                            page: newCurrentPage,
                            perPage: this.perPage,
                            package: this.package
                        }
                    });
                } else {
                    this.$router.replace({
                        path: '/subscription/activated/list',
                        query: {
                            page: newCurrentPage,
                            perPage: this.perPage
                        }
                    });
                }

                this.currentPage = newCurrentPage
                this.$store.dispatch("subscriber/fetchActivated", {
                    perPage: this.perPage,
                    currentPage: newCurrentPage,
                    package: this.package,
                    user_name: this.user_name,
                    date_from: this.date_from,
                    date_to: this.date_to
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false
                });
            }
        },

        perPage(newperPage) {
            if (!this.initialLoad) {
                if (this.package != null && this.package !== '' && this.package !== NaN) {
                    this.$router.replace({
                        path: '/subscription/activated/list',
                        query: {
                            page: this.currentPage,
                            perPage: newperPage,
                            package: this.package
                        }
                    });
                } else {
                    this.$router.replace({
                        path: '/subscription/activated/list',
                        query: {
                            page: this.currentPage,
                            perPage: newperPage
                        }
                    });
                }

                this.perPage = newperPage
                this.$store.dispatch("subscriber/fetchActivated", {
                    perPage: newperPage,
                    currentPage: this.currentPage,
                    package: this.package,
                    user_name: this.user_name,
                    date_from: this.date_from,
                    date_to: this.date_to
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false
                });
            }
        }
    },

    created() {
        this.$store.dispatch("packages/fetchPackage")
    },

    mounted() {
        if (this.initialLoad) {
            if (!this.$route.query.page || !this.$route.query.perPage) {
                this.$router.replace({
                    path: this.$route.path,
                    query: {
                        page: this.currentPage,
                        perPage: this.perPage
                    }
                }).catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        throw err;
                    }
                });
                this.fetchInitial();
            } else {
                this.currentPage = parseInt(this.$route.query.page);
                this.perPage = parseInt(this.$route.query.perPage);
                this.package = parseInt(this.$route.query.package);
                this.fetchInitial();
            }
        }
    },

    methods: {
        validatePage() {
            this.loadingPage = true;
            const totalPages = this.totalPages;

            if (!this.currentPage || isNaN(this.currentPage) || this.currentPage < 1) {
                this.currentPage = 1;
            } else if (Number(this.currentPage) > totalPages) {
                this.currentPage = totalPages; // Set to last valid page
            }

            this.loadingPage = false;
        },

        goToPage(page) {
            if (page < 1 || page > this.totalPages) return;
            this.currentPage = page;
        },

        formatDate(dateStr) {
            if (!dateStr) return ''

            // Split date and time manually
            const [datePart, timePart] = dateStr.replace('Z', '').split('T')

            const [year, month, day] = datePart.split('-')
            const [hourRaw, minute] = timePart.split(':')

            const hours = parseInt(hourRaw)

            const monthNames = [
                'January', 'February', 'March', 'April', 'May', 'June',
                'July', 'August', 'September', 'October', 'November', 'December'
            ]

            const monthName = monthNames[parseInt(month) - 1]

            const ampm = hours >= 12 ? 'PM' : 'AM'
            const hour12 = hours % 12 || 12

            const getOrdinal = (n) => {
                const s = ['th', 'st', 'nd', 'rd']
                const v = n % 100
                return s[(v - 20) % 10] || s[v] || s[0]
            }

            return {
                date: `${parseInt(day)}${getOrdinal(parseInt(day))} ${monthName}, ${year}`,
                time: `${hour12}:${minute} ${ampm}`
            }
        },

        fetchInitial() {
            this.$store.dispatch("subscriber/fetchActivated", {
                perPage: this.$route.query.perPage,
                currentPage: this.$route.query.page,
                package: this.$route.query.package,
                date_from: this.date_from,
                date_to: this.date_to
            }).then(() => {
                this.totalRows = this.count;
                this.initialLoad = false;
            });
        },

        filterUserList() {
            this.filterShow = true;
            this.$store.dispatch("subscriber/fetchActivated", {
                user_name: this.user_name,
                package: this.package,
                perPage: this.$route.query.perPage,
                currentPage: this.$route.query.page,
                date_from: this.date_from,
                date_to: this.date_to
            }).then(() => {
                this.totalRows = this.count;
                this.initialLoad = false;
            });
        },

        resetFilters() {
            this.filterShow = false,
            this.package = null,
            this.user_name = null,
            this.date_from = null;
            this.date_to = null;
            this.$router.replace({
                path: '/subscription/activated/list',
                query: {
                    page: this.currentPage,
                    perPage: this.perPage
                }
            });
            this.fetchInitial();
        },

        searchUsers() {
            if (this.user_name && this.user_name.trim() !== '' && this.user_name.length >= 2) {
                this.$store.dispatch("subscriber/fetchActivated", {
                    user_name: this.user_name,
                    package: this.package,
                    perPage: this.$route.query.perPage,
                    currentPage: this.$route.query.page,
                    date_from: this.date_from,
                    date_to: this.date_to
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }
        },

        clearSearch() {
            this.user_name = null;
            this.fetchInitial();
        },

        togglePaymentTable(itemId) {
            this.$set(this.expandedRows, itemId, !this.expandedRows[itemId]);
        }
    }
};
</script>

<style scoped>
.table-danger {
    background-color: #f8d7da !important;
    color: #721c24 !important;
}

.small-table-container {
    max-width: 300px;
}

.small-table {
    width: 100%;
    font-size: 12px;
    border-collapse: collapse;
}

.small-table th,
.small-table td {
    padding: 6px;
    border: 1px solid #ddd;
    text-align: left;
}

.small-table th {
    background-color: #262062;
    color: white;
    font-weight: 600;
}

.small-table tbody tr:hover {
    background-color: #f5f5f5;
}
</style>
